<template>
  <li class="flex gap-2 md:gap-6 items-center">
    <UIcon name="workbook-ring" class="bullet size-6 md:size-8" />
    <span class="bullet-text"><slot /></span>
  </li>
</template>
